import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  getStrains: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.get('/strain', {
        params: payload
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'strains',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.FilteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.FilteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  insert: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.post('/strain', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  get: async ({ commit }, id) => {
    try {
      const res = await axios.get(`/strain/${id}`)
      commit('SET_STATE', {
        action: 'strain',
        data: res.data.strain
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  update: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`/strain/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  delete: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.delete(`/strain/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  // update strain status
  updateStrainStatus: async ({ commit }, { id, status }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.put(`/strain/${id}/update-status`, {
        status
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  }
}
